var globals = {
  REACT_APP_URL_BASE_API: process.env.REACT_APP_URL_BASE_API,
  REACT_APP_URL_BASE_FRONT_PORTAL: process.env.REACT_APP_URL_BASE_FRONT_PORTAL,
  REACT_APP_APIADDRESS_CEP: process.env.REACT_APP_APIADDRESS_CEP,
  REACT_APP_TERMO_USO: process.env.REACT_APP_TERMO_USO,
};
export default globals;
